import { convertDistance, DistanceUnit } from '@backend/lib-l10n-logic';

import { JobOfferSort } from '~/constants/jobOffer';
import { getDistanceConfig } from '~/utils/search/getDistanceConfig';
import type { DefaultSearchParams } from '~/utils/search/types';

export const getDefaultParams = (country: string): DefaultSearchParams => {
  const { maxDistance, unit } = getDistanceConfig(country);
  return {
    page: 1,
    distance: convertDistance({ value: maxDistance, unit }, DistanceUnit.KM).value,
    sort: JobOfferSort.relevance,
  };
};
